import servicesAction from '@/store/modules/cloud/connections/services.action';
import servicesMutation from '@/store/modules/cloud/connections/services.mutations';

interface Services {
  id: String;
  serviceName: String;
  serviceNameSlug: String;
}

interface Connections {
  connectionName: String;
  subscriptionId: String;
  services: Services[];
  aliasEnabled: Boolean;
  createdBy: String;
  updatedAt: String;
}

export interface State {
  allConnections: Connections[];
  apiCallStatus: 'loading' | 'success' | 'failed' | 'idle';
  errorMessage: String;
  searchedService: String;
}

const initialState: State = {
  allConnections: [],
  apiCallStatus: 'idle',
  errorMessage: '',
  searchedService: '',
};

export default {
  namespaced: true,
  state: initialState,
  mutations: servicesMutation,
  actions: servicesAction,
};
